export default __webpack_public_path__ + "static/media/logo_infonavit.264caabb.svg";